import React from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import DuperbrowseStreamContextProvider from './DuperbrowseStreamContextProvider';

export interface Props {
  streamId: string;
  deviations: PapiDeviation[];
  preloadEnabled?: boolean;
  parent?: {
    title?: string;
    typeId?: number;
    itemId?: number;
  };
}

const DeviationDuperbrowseContext: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  deviations,
  streamId,
  parent,
  preloadEnabled = true,
}) => {
  return (
    <DuperbrowseStreamContextProvider
      stream={{
        items: deviations,
        streamId,
        parent,
        preloadEnabled,
      }}
    >
      {children}
    </DuperbrowseStreamContextProvider>
  );
};
DeviationDuperbrowseContext.displayName = 'DeviationDuperbrowseContext';

export default DeviationDuperbrowseContext;
